import { render, staticRenderFns } from "./AppShell.vue?vue&type=template&id=2611fd0c&scoped=true"
import script from "./AppShell.vue?vue&type=script&lang=js"
export * from "./AppShell.vue?vue&type=script&lang=js"
import style0 from "./AppShell.vue?vue&type=style&index=0&id=2611fd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2611fd0c",
  null
  
)

export default component.exports